export const itemNameRegex: (text: string) => string = (text: string): string => {
    return text.toLowerCase().replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
};

export const itemNamesRegex: RegExp = /\d+\.\s*(.+)/;

export const riddleRegex: RegExp = /Here's your next riddle:\s*(.+\?)\s*/i;
